<template>
  <v-card
      height="330"
      class="rounded-lg white"
  >
    <v-card-title class=" mr-3 mt-3 secondary--text">
      <v-img class="ml-3" src="/img/icons/users.svg" max-width="25" max-height="25"></v-img>
      کاربر های <span class="success--text mr-2">فعال</span>
      <v-spacer></v-spacer>
      <v-tooltip right >
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" fab icon class="mr-3" href="users">
            <v-img class="" src="/img/icons/info_circle.svg" max-width="23"></v-img>
          </v-btn>
        </template>
        مشاهده کامل
      </v-tooltip>
    </v-card-title>
    <v-simple-table class="mr-2 ml-2 rounded-b-lg">
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-center">
            نام
          </th>
          <th class="text-center">
            نام خانوادگی
          </th>
          <th class="text-center">
            نام کاربری
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="user in users" v-if="user.is_active">
          <td class="text-center">{{user.user.first_name}}</td>
          <td class="text-center">{{user.user.last_name}}</td>
          <td class="text-center">{{user.user.username}}</td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
export default {
  name: "ActiveUsers",
  components: {
  },
  props: {
    id: {},
  },
  data() {
    return {
      users: null,
    };
  },
  mounted() {
    this.request({
      url: this.endpoint('companies/companyUsers/'),
      method: "get",
      success: data => {
        this.users = data.slice(0, 4)
      },
    })


  }


}
</script>

<style scoped lang="scss"></style>

